export type CrmDateField = 'entry' | 'won' | 'lost' | 'lead_arrival';

export const DEFAULT_CRM_DATE_FIELD: CrmDateField = 'entry';

export const CRM_DATE_FIELD_OPTIONS: {
  value: CrmDateField;
  label: string;
  fromLabel: string;
  toLabel: string;
}[] = [
  {
    value: 'entry',
    label: 'Data de entrada',
    fromLabel: 'Entrada a partir de',
    toLabel: 'Entrada até',
  },
  {
    value: 'won',
    label: 'Data de ganho',
    fromLabel: 'Ganho a partir de',
    toLabel: 'Ganho até',
  },
  {
    value: 'lost',
    label: 'Data de perda',
    fromLabel: 'Perda a partir de',
    toLabel: 'Perda até',
  },
  {
    value: 'lead_arrival',
    label: 'Chegada do lead',
    fromLabel: 'Chegada a partir de',
    toLabel: 'Chegada até',
  },
];

export function getCrmDateFieldOption(dateField: CrmDateField) {
  return (
    CRM_DATE_FIELD_OPTIONS.find((option) => option.value === dateField) ??
    CRM_DATE_FIELD_OPTIONS[0]
  );
}

/** Resolve the date used for CRM period/range filters. */
export function getOpportunityFilterDate(
  opp: {
    created_at: string;
    sale_date?: string | null;
    closed_at?: string | null;
    contact_created_at?: string | null;
  },
  dateField: CrmDateField
): Date | null {
  let raw: string | null | undefined;

  switch (dateField) {
    case 'entry':
      raw = opp.created_at;
      break;
    case 'won':
      raw = opp.sale_date || opp.closed_at;
      break;
    case 'lost':
      raw = opp.closed_at;
      break;
    case 'lead_arrival':
      raw = opp.contact_created_at;
      break;
    default:
      raw = opp.created_at;
  }

  if (!raw) return null;
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function opportunityNeedsContactInnerJoin(dateField: CrmDateField): boolean {
  return dateField === 'lead_arrival';
}

/**
 * Apply a lower-bound date filter on account_opportunities (and contact when needed).
 * `won` uses sale_date with fallback to closed_at (same rule as reports).
 */
export function applyOpportunityDateGte<T>(
  query: T,
  dateField: CrmDateField,
  fromIso: string
): T {
  const q = query as {
    gte: (column: string, value: string) => T;
    or: (filters: string) => T;
  };
  const quoted = `"${fromIso}"`;

  switch (dateField) {
    case 'entry':
      return q.gte('created_at', fromIso);
    case 'won':
      return q.or(
        `sale_date.gte.${quoted},and(sale_date.is.null,closed_at.gte.${quoted})`
      );
    case 'lost':
      return q.gte('closed_at', fromIso);
    case 'lead_arrival':
      return q.gte('contact.created_at', fromIso);
    default:
      return q.gte('created_at', fromIso);
  }
}
